module.exports = __webpack_public_path__ + "static/img/zhanwei1.a21afb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhanwei1.png
// module id = bHEz
// module chunks = 1